// GeoJsonContext.js
import React, { createContext, useContext, useState } from 'react';

// Create the context
const GeoJsonContext = createContext();

// Create a provider component
export const GeoJsonProvider = ({ children }) => {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [geoArea, setGeoArea] = useState(null);

  return (
    <GeoJsonContext.Provider value={{ geoJsonData, setGeoJsonData, geoArea, setGeoArea }}>
      {children}
    </GeoJsonContext.Provider>
  );
};

// Custom hook to use the GeoJsonContext
export const useGeoJson = () => useContext(GeoJsonContext);